import { ARROW_POSITION } from '../../services/constants';
var top = ARROW_POSITION.top,
  bottom = ARROW_POSITION.bottom;
export function getArrowColumnWidth(isMobile, arrowsPositionMobile) {
  if (isMobile) {
    if (arrowsPositionMobile === top || arrowsPositionMobile === bottom) {
      return 8;
    }
  }
  return 1;
}
export function getItemsColumnWidth(isMobile, displayControls, arrowsPositionMobile) {
  if (!displayControls) {
    return 16;
  }
  if (isMobile) {
    if (arrowsPositionMobile === top || arrowsPositionMobile === bottom) {
      return 16;
    }
  }
  return 14;
}